import React from 'react';
import type { LinkT } from '@mentimeter/ragnar-ui/link';
import { useTranslations } from 'next-intl';
import { NavLink } from './NavLink';

export const LoginButton = (linkProps: LinkT) => {
  const t = useTranslations('first_impression.legacy.common');

  return (
    <NavLink
      aria-label={t('page_links.login_aria')}
      href="/auth/login"
      data-testid="page-header-login"
      active={false}
      {...linkProps}
    >
      {t('page_links.login')}
    </NavLink>
  );
};
